"use strict";

/**
 * Created by Andreas on 31/01/16.
 *
 * DON NOT EDIT THIS FILE DIRECTLY - PLEASE USE THE JSX SOURCE FILE
 */

import Widgets from 'js-widget-hooks';
import trans from './util/translator';
import './components/widgets';
import './components/widgets-center';
import './components/widgets-custom';
import './util/piwik';

// the special widgets
import './specialwidgets.jsx';

trans.setLocale(GLOBAL_CONFIG.site_locale);

Widgets.init();